import React, { useState } from 'react';

interface ICoinButtonProps {
  text: string;
  img: string;
  onClick?: () => void;
}

const divStyles = {
  width: 'fit-content',
  borderRadius: '25px',
  padding: '10px 20px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  justifyContent: 'space-between',
  color: 'white',
  cursor: 'pointer',
  fontSize: '12px',
  transition: '250ms all ',
  fontWeight: 600,
} as React.CSSProperties;

const CoinButton = ({ text, img, onClick }: ICoinButtonProps) => {
  const [selected, setSelected] = useState<boolean>(false);
  return (
    <div
      style={{
        ...divStyles,
        backgroundColor: selected ? '#DDB930' : '#444252',
      }}
      onClick={() => {
        setSelected(!selected);
        if (onClick) onClick();
      }}
    >
      <img style={{ width: '20px', height: '20px' }} src={img} alt="" />
      {text}
    </div>
  );
};

export default CoinButton;
